var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n  source ext id"),_c('br'),_vm._v("\n  "+_vm._s(_vm.action.sourceExtId)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }